"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var toolkit_1 = require("@reduxjs/toolkit");
var constants_1 = require("./constants");
exports.setDateString = function (dateString) { return toolkit_1.createAction(constants_1.SET_DATE_STRING)(dateString); };
exports.setDisableRCU = function (isDisabled) {
    return toolkit_1.createAction(constants_1.SET_IS_DISABLED_RCU)(isDisabled);
};
exports.setIsMenuOpen = function (isOpen) { return toolkit_1.createAction(constants_1.SET_IS_MENU_OPEN)(isOpen); };
exports.setIsOnScreenGuideVisible = function (isVisible) {
    return toolkit_1.createAction(constants_1.SET_IS_ON_SCREEN_GUIDE_VISIBLE)(isVisible);
};
exports.setLongPressModeId = function (longPressId) {
    return toolkit_1.createAction(constants_1.SET_LONG_PRESS_MODE_ID)(longPressId);
};
exports.setIsKeyBoardOpen = function (isOpen) { return toolkit_1.createAction(constants_1.SET_KEYBOARD_OPEN)(isOpen); };
exports.setIsIPFailover = function (isIPFailover) {
    return toolkit_1.createAction(constants_1.SET_IS_IP_FAILOVER)(isIPFailover);
};
//# sourceMappingURL=actions.js.map